import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const StyledCategoryContainer = styled.div`
    display: inline-flex;
    width: 100%;
    align-items: center;
    margin-bottom: 5px;
`;

export const StyledContainer = styled.div`
    display: flex;
`;

export const StyledCategoryName = styled.h3`
    font-family: 'AvenirNextWorld Demi';
    margin: 0;
    color: #140f4b;
    font-size: 18px;
    line-height: 22px;
    ${media.mobileDevice`
    font-size: 20px;
        line-height: 34px;
    `}
`;

export const ArrowContainer = styled.div`
    display: flex;
    margin-left: 10px;
    box-sizing: border-box;
    width: 3rem;
    height: 100%;
    align-items: center;
`;

export const ImageContainer = styled.img`
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : '')};
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
`;
